import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  RoleInCompanyFormType,
  FormErrors,
  getSchema,
} from '../../forms/roleInCompanyForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: RoleInCompanyFormType;
  onSubmit: (values: RoleInCompanyFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitDisabled?: boolean;
  submitLoading?: boolean;
}

export const RoleInCompany = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onSubmit,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t, formProps.enabledCivilLawSubject);

  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.roleInCompany.subtitle')}
      title={t('onboarding.roleInCompany.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
